import {ModalService} from "./ModalService";
import {needCloseOnEscape} from "./IModalOptions";

let escEnabled = true;

export function enableModalEscKey(enable: boolean) {
  escEnabled = enable;
}

export function closeModalOnEsc(modalService: ModalService) {
  window.addEventListener("keydown", (evt: KeyboardEvent) => {

    if (!modalService.isOpen() || !escEnabled) {
      return;
    }
    const last = modalService.getLast();
    if (!needCloseOnEscape(last.options)) {
      return;
    }
    switch (evt.which) {
      case 27: {
        evt.preventDefault();
        modalService.closeLast();
        break;
      }
    }
  });

  return () => Promise.resolve();
}
